module.exports = __webpack_public_path__ + "static/media/VadymPospielov.a6cbc334.png";